// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1S77w","modalForm":"UpgradeEpcsModal_modalForm__uiO3v","modalFooter":"UpgradeEpcsModal_modalFooter__i59-2"};